import React from 'react';
import { cn } from '@/lib/utils';
import { Paper } from '@/stores/slices/paperSlice';
import { Tip } from '@/components/fun-ui/Tip';
import { AbstractIcon } from '@/components/fun-ui/icons/AbstractIcon';

export interface PaperBadgeProps {
  paper?: Paper;
  className?: string;
  isAbstract?: boolean;
}

export function PaperBadge({
  paper,
  className,
  isAbstract = false
}: PaperBadgeProps) {

  // 显示摘要标志
  if (paper?.attachmentId?.toString() === '0' || isAbstract === true) {
    return (
      <Tip label="该文献仅含有摘要内容" side="right" align="center">
        <AbstractIcon
          className={cn("text-annotation-foreground shrink-0", className)}
          size={26}
        />
      </Tip>
    );
  }

  return null;
}
